import { createSlice } from '@reduxjs/toolkit'

export const selectedStatementSlice = createSlice({
    name: 'selectedStatement',
    initialState: {
        result: null,
    },
    reducers: {
        setSelectedStatement: (state, action) => {
            state.result = action.payload;
        }
    },
})

export const { setSelectedStatement } = selectedStatementSlice.actions;

export const getSelectedStatement = (state) => state.selectedStatement.result;

export default selectedStatementSlice.reducer